/**
 * Created by ZengFanHui on 18/05/11.
 */
import http from './httpRequest'
const _import = require('../router/_import_' + process.env.NODE_ENV)

/**
 * 根据当前路由动态为当前路由添加子路由
 * @param router
 * @param currentRoute
 */
export function dynamicChangeRoute (router, currentRoute, type = 'edit') {
  let currentRouteName = currentRoute.name
  let currentRoutePath = currentRoute.path

  var route = {
    path: `${currentRoutePath}/${type}/:id`,
    component: _import(`${insertStr2LowCase(currentRoutePath).replace(/^\//, '')}-${type}`),
    name: `${currentRouteName.replace('/', '-')}-${type}`,
    meta: {
      id: currentRoute.meta.id,
      title: currentRoute.meta.title,
      menuName: currentRoute.meta.menuName,
      isDynamic: true
    }
  }

  let dynamicMenuRoutes = JSON.parse(sessionStorage.getItem('dynamicMenuRoutes'))

  let isRouteExists = dynamicMenuRoutes.filter(item => {
    return item.path === route.path
  })

  if (isRouteExists.length === 0) {
    dynamicMenuRoutes.push(route)
  }

  sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(dynamicMenuRoutes || '[]'))
  const mainRoutes = {
    path: '/',
    component: _import('main/index'),
    meta: { title: '主入口整体布局' },
    children: dynamicMenuRoutes
  }
  //
  return mainRoutes
}

/**
 * 判断对象是否为空
 * @param obj
 * @return {boolean}
 */
export function isObjectEmpty (obj) {
  var arr = Object.keys(obj)
  if (arr.length === 0) {
    return true
  }
  return false
}

/**
 * 网络请求
 * @param url
 * @param method
 * @param data
 * @return {*}
 */
export function doHttp (url, method, data, type) {
  let obj = {
    url: http.adornUrl(url),
    method
  }

  if (method === 'get' || method === 'GET') {
    obj.params = http.adornParams(data)
  } else if (method === 'post' || method === 'POST') {
    obj.data = http.adornData(data, type)
  }

  return http(obj)
}

/**
 * 网络请求2
 * @param url
 * @param method
 * @param data
 * @return {*}
 */
export function doHttp2 (url, method, data, type) {
  let obj = {
    url,
    method
  }

  if (method === 'get' || method === 'GET') {
    obj.params = http.adornParams(data)
  } else if (method === 'post' || method === 'POST') {
    obj.data = http.adornData(data, type)
  }

  return http(obj)
}

/**
 * 转换菜单结构
 * @param data
 * @return {Array}
 */
export function menuDataTranslate (data) {
  let menuList = []

  let mainNameList = []
  // 提取一级菜单
  for (let i in data) {
    if (!mainNameList.includes(data[i].mainName)) {
      mainNameList.push(data[i].mainName)
      menuList.push({
        name: data[i].mainName,
        sort: data[i].sort,
        subMenu: []
      })
    }
  }

  for (let i in data) {
    for (let j in menuList) {
      let temp = {}
      if (menuList[j].name === data[i].mainName) {
        temp.mainName = data[i].mainName
        temp.name = data[i].subName
        temp.id = data[i].id
        temp.url = data[i].url
        temp.icon = data[i].icon
        menuList[j].subMenu.push(temp)
      }
    }
  }
  // 排序后再返回
  menuList.sort((n, m) => {
    return n.sort - m.sort
  })
  return menuList
}

/**
 * 将字符串中大写字母前加上"-"，并将大写转小写返回
 * @example 'abcdEfgHi' -> 'abcd-efg-hi'
 * @param str
 * @return {*}
 */
export function insertStr2LowCase (str) {
  const regex = /[A-Z]/g
  let index = str.search(regex)
  let result = str
  if (index !== -1) {
    result = str.slice(0, index) + '-' + str.slice(index, index + 1).toLowerCase() + str.slice(index + 1)
  }

  let isHaveUpperCase = result.search(regex)
  if (isHaveUpperCase === -1) {
    return result
  } else {
    return insertStr2LowCase(result)
  }
}

/**
 * 格式化日期
 * @param date
 * @param fmt
 * @return {*}
 */
export function formatDate (date, fmt = 'YYYY-MM-DD HH:mm:ss') {
  if (!date) {
    return ''
  }
  if (typeof date === 'string') {
    date = new Date(date.replace(/-/g, '/'))
  }
  if (typeof date === 'number') {
    date = new Date(date)
  }
  var o = {
    'M+': date.getMonth() + 1,
    'D+': date.getDate(),
    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  var week = {
    '0': '\u65e5',
    '1': '\u4e00',
    '2': '\u4e8c',
    '3': '\u4e09',
    '4': '\u56db',
    '5': '\u4e94',
    '6': '\u516d'
  }
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '\u661f\u671f' : '\u5468') : '') + week[date.getDay() + ''])
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

/**
 * 计算日期相差天数
 * @param sDate1
 * @param sDate2
 * @return {Number|*}
 */
export function dateDiff (sDate1, sDate2) {
  let oDate1
  let oDate2
  let iDays
  oDate1 = new Date(sDate1)
  oDate2 = new Date(sDate2)
  iDays = parseInt((oDate1 - oDate2) / 1000 / 60 / 60 / 24)
  return iDays
}

/**
 * 获取传入日期所在月份的天数
 * @param date
 */
export function monthDays (date) {
  date = new Date(date)
  let fullYear = date.getFullYear()
  let month = date.getMonth() + 1
  let d = new Date(fullYear, month, 0)
  return d.getDate()
}

/**
 * 计算日期相差天数2
 * @param sDate1
 * @param sDate2
 * @return {*}
 */
export function dateDiff2 (sDate1, sDate2) {
  let oDate1
  let oDate2
  let iDays
  oDate1 = new Date(sDate1)
  oDate2 = new Date(sDate2)
  iDays = timeago(oDate1 - oDate2)
  return iDays
}

/**
 * 时间转换
 * @param diffValue
 * @return {*}
 */
export function timeago (diffValue) {
  var second = 1000 * 1
  var minute = second * 60
  var hour = minute * 60
  var day = hour * 24
  var week = day * 7
  var halfamonth = day * 15
  var month = day * 30
  var result = ''

  if (diffValue < 0) {
    return
  }
  var secondC = diffValue / second
  var minC = diffValue / minute
  var hourC = diffValue / hour
  var dayC = diffValue / day
  var weekC = diffValue / week
  var monthC = diffValue / month
  if (monthC >= 1 && monthC <= 3) {
      result = '持续' + parseInt(monthC) + '月'
  } else if (weekC >= 1 && weekC <= 3) {
      result = '持续' + parseInt(weekC) + '周'
  } else if (dayC >= 1 && dayC <= 6) {
      result = '持续' + parseInt(dayC) + '天'
  } else if (hourC >= 1 && hourC <= 23) {
      result = '持续' + parseInt(hourC) + '小时'
  } else if (minC >= 1 && minC <= 59) {
      result = '持续' + parseInt(minC) + '分钟'
  } else if (diffValue >= 0 && diffValue <= minute) {
      result = '持续' + parseInt(secondC) + '秒'
  } else {
      result = '-'
  }
  return result
}

/**
 * jcp数据格式化
 * @param list
 * @return {*}
 */
export function dataFormart(list) {
  let dataset = []
  list.forEach(item => {
    let obj = {
      '唯一码': item.detailNumber,
      '条形码': item.batchNumer,
      '模板logo': item.logoUrlPath,
      '产品名称': item.productName,
      '产品标准编号': '产品标准编号：' + item.standardNumber,
      '生产日期': '生产日期：' + item.productDate,
      '净含量': '净含量：' + item.netWeight,
      '保质期': '保质期为' + item.period,
      '二维码': item.numberUrl,
      '畜牧局二维码': item.url,
      '合格证': 'http://dddy.sen-chang.cn/tms-resources/01.png',
      '公司名称': '生产者名称: ' + item.companyName,
      '生产许可证': '饲料生产许可证编号: ' + item.companyLicense,
      '公司生产地址': '生产地址：' + item.companyAddress,
      '公司注册地址': '注册地址：' + item.companyRegisterAddress,
      '公司邮政编码': '邮编：' + item.companyPostCode,
      '公司联系方式': '电话/传真：' + item.companyContactNumber + '/' + item.companyTel,
      '委托方公司名称': '委托企业：' + item.entrustCompanyName,
      '委托方许可证号': item.entrustCompanyLicense,
      '委托方公司生产地址': '委托方生产地址：' + item.entrustCompanyAddress,
      '委托方公司注册地址': '委托方注册地址：' + item.entrustCompanyRegisterAddress,
      '委托方公司联系方式': '电话：' + item.entrustCompanyContactNumber,
      '委托方公司邮政编码': '邮编：' + item.entrustCompanyPostCode
    }
    dataset.push(obj)
  })
  return dataset
}
